'use client';

import React, { type FC } from 'react';
import { tabsTriggerVariants } from '@paypoteam/page-components';
import { Button } from '@paypoteam/ui-components';
import * as Sentry from '@sentry/nextjs';
import Link from 'next/link';

import { cn } from '@/lib/utils';

import type { CategoryButtonsProps } from '../SectionShopSearch.types';
import { categoryPath, getCategory } from '../utils/getCategory';

const CategoryButtons: FC<CategoryButtonsProps> = ({
    categoryData,
    customButton,
    showFilterNew = false,
    className,
    ...props
}) => {
    const { title: buttonTitle, isActive, handleClick } = customButton;

    const category = getCategory();

    return (
        <ul
            className={cn(
                'flex w-full flex-row flex-wrap gap-5 pb-7',
                className,
            )}
            {...props}
        >
            {showFilterNew && !!Object.keys(customButton).length && (
                <li>
                    <Button
                        onClick={e => {
                            e.preventDefault();

                            Sentry.addBreadcrumb({
                                category: 'shop search',
                                message:
                                    'click to category button' + buttonTitle,
                                level: 'info',
                            });

                            handleClick();
                        }}
                        data-state={isActive ? 'active' : 'inactive'}
                        className={cn(
                            tabsTriggerVariants({
                                variant: 'secondary',
                                size: 'm',
                            }),
                        )}
                    >
                        {buttonTitle}
                    </Button>
                </li>
            )}

            {categoryData.length &&
                categoryData.map(({ slug, title: categoryName, type }) => {
                    const subcategoryName = slug.split('/').shift();

                    return (
                        <li
                            key={slug}
                            className="flex max-h-10"
                        >
                            <Link
                                href={`/p/${categoryPath}/${
                                    type === 'subcategory'
                                        ? `${category}/${subcategoryName}`
                                        : slug
                                }`}
                                className={cn(
                                    tabsTriggerVariants({
                                        variant: 'secondary',
                                        size: 'm',
                                    }),
                                )}
                            >
                                {categoryName}
                            </Link>
                        </li>
                    );
                })}
        </ul>
    );
};

export default CategoryButtons;
